import { Textarea } from '@dreryk/react-components';

import { visitSettlementTranslationKeys } from '../../../translations';
import { VisitSettlementFormController } from '../VisitSettlementForm';

const t = visitSettlementTranslationKeys.shared.form.adjustment.noteField;

type AdjustmentNoteFieldProps = Pick<VisitSettlementFormController, 'register'>;

export const AdjustmentNoteField = (props: AdjustmentNoteFieldProps): JSX.Element => {
   return (
      <Textarea
         rows={6}
         maxRows={6}
         placeholder={t.placeholder}
         label={t.label}
         controller={props.register('adjustment.note')}
         maxLength={500}
         testId={'adjustmentNote'}
         defaultValue={null}
      />
   );
};
